<template>
  <div class="height-100vh">
    <b-card
      title="Please waiting for Authentication User..."
      class="text-center custom-card-height"
    >
      <b-img fluid :src="imgUrl" class="custom-max-height" alt="Callback" />
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BImg } from "bootstrap-vue"
import mixins from "@/mixins"

export default {
  components: {
    BCard,
    BCardText,
    BImg,
  },
  mixins: [mixins],
  data() {
    return {
      imgUrl: require("@/assets/images/pages/not-authorized.svg"),
    }
  },
  async created() {
    await this.$store.dispatch("appConfig/setLayoutSidebar", false)
    await this.$store.dispatch("authStore/handleCallback")
    await this.$store.dispatch("siteStore/fetchSite")

    this.setDashboardAutoRefresh(true, [
      "WPM",
      "WPMExecutive",
      "WPMSiteAccess",
      "SMS",
      "BMM",
      "NCM",
    ])

    this.$router.push("/internal")
    this.toastSuccess("Login Successfully")
  },
  methods: {
    setDashboardAutoRefresh(value, dashboards) {
      dashboards.forEach((dashboard) => {
        const methodName = `set${dashboard}DashboardAutoRefresh`
        this.$store.dispatch(`appAutoRefresh/${methodName}`, value)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-max-height {
  max-height: 500px;
}

.card .card-title {
  font-size: 24px;
}

.card-body {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}
</style>
